var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep10To8Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 166,
    viewBox: "0 0 65 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6464 4.14645C12.4512 4.3417 12.4512 4.65829 12.6464 4.85354L15.8284 8.03553C16.0237 8.23078 16.3403 8.23079 16.5355 8.03553C16.7308 7.84027 16.7308 7.52369 16.5355 7.32843L13.7071 4.5L16.5355 1.67157C16.7308 1.4763 16.7308 1.15972 16.5355 0.964458C16.3403 0.769207 16.0237 0.769207 15.8284 0.964458L12.6464 4.14645ZM-1.52996e-05 165.5L44 165.5L44 164.5L-1.5218e-05 164.5L-1.52996e-05 165.5ZM64.5 145L64.5 24.5L63.5 24.5L63.5 145L64.5 145ZM44 4L13 4L13 5L44 5L44 4ZM64.5 24.5C64.5 13.1781 55.3218 4 44 4L44 5C54.7696 5 63.5 13.7304 63.5 24.5L64.5 24.5ZM44 165.5C55.3218 165.5 64.5 156.322 64.5 145L63.5 145C63.5 155.769 54.7696 164.5 44 164.5L44 165.5Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep10To8Mobile);
export default __webpack_public_path__ + "static/media/step_10_to_8_mobile.6ae3d0bcc9acce223d8b9220144ef357.svg";
export { ForwardRef as ReactComponent };